// ============================================================
// MatiereFournie — « matière fournie par le client », en tête du bloc
// Matière. 6 octobre 2026.
// ------------------------------------------------------------
// Elle vivait dans les Réglages (« Ce qui prévaut sur l'estimation »),
// loin de la matière qu'elle annule. Cochée, le reste du bloc se GRISE
// (`PieceMaterial`) : une nuance et un prix au kilo qui s'affichent
// normalement se liraient comme comptés.
//
// §1.4 : le coût matière est nul et la pièce reste complète — c'est un
// zéro DÉCIDÉ, le seul du calcul (invariant 5). Une seule porte : la case
// n'existe plus dans `EncartPrevaut`.
// ============================================================

export function MatiereFournie({ piece, disabled, onChange }) {
  return (
    <label className="row matiere-fournie">
      <input
        type="checkbox"
        aria-label="Matière fournie par le client"
        checked={piece.matiere_fournie_client === true}
        disabled={disabled}
        onChange={(e) => onChange({ matiere_fournie_client: e.target.checked })}
      />
      <span>
        <strong>Matière fournie par le client</strong> — coût matière nul, la pièce reste complète.
      </span>
    </label>
  );
}

export default MatiereFournie;
